import { motion } from "framer-motion";
import { Car, Home, Wrench, Sun, Scale, Building2 } from "lucide-react";

const categories = [
  { icon: Car, label: "Auto", count: "12K+" },
  { icon: Home, label: "Real Estate", count: "8K+" },
  { icon: Wrench, label: "Skilled Trades", count: "5K+" },
  { icon: Sun, label: "Solar Market", count: "3K+" },
  { icon: Scale, label: "Legal Directory", count: "2K+" },
  { icon: Building2, label: "Businesses", count: "15K+" },
];

const MarketplaceSection = () => {
  return (
    <section className="py-4 md:py-24 mt-4 md:mt-0">
      <div className="container px-4">
        <motion.div
          className="text-center mb-4 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-sm font-medium text-accent uppercase tracking-wider">Market Hub</span>
          <h2 className="font-display text-2xl md:text-5xl font-bold mt-2 md:mt-3 mb-2 md:mb-4">
            A Market Hub for <span className="gradient-text">Everything</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-sm md:text-base">
            Browse listings across dozens of categories — from cars to solar panels to legal services.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat, i) => (
            <motion.div
              key={cat.label}
              className="group flex flex-col items-center p-4 md:p-6 rounded-2xl bg-card shadow-card hover:shadow-card-hover transition-all cursor-pointer text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-2 md:mb-3 group-hover:bg-primary group-hover:text-primary-foreground transition-colors text-primary">
                <cat.icon className="w-6 h-6 md:w-7 md:h-7" />
              </div>
              <span className="font-display font-semibold text-sm">{cat.label}</span>
              <span className="text-muted-foreground text-xs mt-1">{cat.count} listings</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketplaceSection;
